export default "__VITE_ASSET__f8483970__"